import { getOfferApy } from "../EarnOffer";
import Big from "big.js";
import { atom, useAtom, useAtomValue } from "jotai";
import { FunctionalComponent } from "preact";

import { Icon } from "@/icons";
import { Button, Card, PointList, SectionBar, Text } from "@/uikit";

import { earnApyAtom } from "@/api/earn";
import { offers } from "@/pages/Earn/offers";
import { formatNumber } from "@/utils/numbers";

type BoostCardProps = {
  baseApy: number;
  visible: boolean;
};

const boostState = atom(true);

export const BoostCard: FunctionalComponent<BoostCardProps> = (
  { baseApy, visible },
) => {
  const [active, setActive] = useAtom(boostState);
  const apyData = useAtomValue(earnApyAtom);

  const maxApy = Math.max(
    ...offers
      .map((offer) => getOfferApy(offer.sections, apyData))
      .map((x) => x.toNumber()),
  );

  return (
    <Card className="boost-card gap-vertical" data-visible={visible}>
      <div className="boost-card-header">
        <Text>
          <Text weight="semibold" embed>
            {formatNumber(Big(baseApy + maxApy * +active), false, 2)}%
          </Text>{" "}
          in total
        </Text>
        <Button
          className="boost-card-button"
          onClick={() => setActive((x) => !x)}
          data-active={active}
        >
          <Icon iconKey={active ? "closealt" : "lightning"} />
          <Text variant="body" weight="semibold">
            Earn More
          </Text>
        </Button>
      </div>
      <SectionBar
        sections={[
          {
            color: "purple",
            size: baseApy,
            active: true,
          },
          {
            color: "cyan",
            size: maxApy,
            active,
          },
        ]}
      />
      <PointList
        points={[
          {
            active: true,
            color: "purple",
            contents: `${formatNumber(
              Big(baseApy),
              false,
              2,
              false,
            )}% – Tonstakers Staking`,
            visible: true,
          },
          {
            active,
            color: "cyan",
            contents: `${formatNumber(
              Big(maxApy),
              false,
              2,
              false,
            )}% – Tonstakers Earn`,
            visible: true,
          },
        ]}
      />
    </Card>
  );
};
